import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import signupImage from "../../assets/images/SignUp/signupImage.webp";
// import FacebookLogo from "../../assets/images/SignUp/FacebookLogo.png";
// import GoogleLogo from "../../assets/images/SignUp/GoogleLogo.png";
import x from "../../assets/images/X.png";
import { useSelector } from "react-redux";
import {
  forgotPassword,
  getUserDataByEmail,
} from "../../utils/firebase/firebase.utils";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function ForgetPassword({ forgetShow, handleforgetShow, handleSignIn }) {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [emailReq, setEmailReq] = useState(false);
  const [password, setpassword] = useState("");
  const [emailVal, setEmailVal] = useState(t("Required field"));
  const [showpassword, setShowpassword] = useState(false);
  const [wrongPassword, setWrongPassword] = useState(false);
  const [isUsernameExist, setIsUsernameExist] = useState(false);
  const [show, setshow] = useState(true);
  const [showVerify, setshowVerify] = useState(false);
  const [logining, setLogining] = useState(false);
  const { users } = useSelector((store) => store.allproducts);

  const sendForgetPassword = async () => {
    setLogining(true);
    try {
      //console.log(email);
      //console.log(users.filter((user)=>user.email==email));
      const userArray = await getUserDataByEmail(email); //users.filter((user)=>user.email==email);
      if (userArray) {
        const resp = await forgotPassword({
          sendEmailTo: email,
          userName: userArray.username,
          email: email,
        });
        console.log("resp", resp);

        if (resp == "1") {
          setEmail("");
          setLogining(false);
          handleforgetShow(false);
          handleSignIn(true);
        }
        if (resp == "auth/email-not-found") {
          setEmailReq(true);
          if (i18n.language == "en") {
            setEmailVal("No such email exist");
          } else {
            setEmailVal("لا يوجد مثل هذا البريد الإلكتروني");
          }
          setLogining(false);
        }

        //console.log(user);
      } else {
        setEmailReq(true);
        if (i18n.language == "en") {
          setEmailVal("No such email exist");
        } else {
          setEmailVal("لا يوجد مثل هذا البريد الإلكتروني");
        }
        setLogining(false);
      }
    } catch (error) {
      setLogining(false);
      console.log(error);
    }
  };

  //   const ForgetPassword = async () => {
  //     const existUsername = await checkUsername(email);
  //     if (!existUsername) {
  //       if (isProvider) {
  //         const { user } = await signInWithGoogle();
  //         const serDocref = await createUserDocumentFromAuth(user);
  //       } else {
  //         if (password < 6) return;
  //         try {
  //           const { user } = await createUserWithEmailAndPassword(
  //             auth,
  //             email,
  //             password
  //           );
  //           setEmail(email.toLowerCase());
  //           const serDocref = await createUserDocumentFromAuth(user, {
  //             email,
  //             firstName,
  //             lastName,
  //             phone:'+'+phoneNumber,
  //           });
  //         } catch (error) {
  //           if (error.code === "auth/email-already-in-use") {
  //             alert("Cann't create user, email already used");
  //           }
  //           console.log(error);
  //         }
  //       }
  //     } else {
  //       setIsUsernameExist(existUsername);
  //     }
  //   };

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const handleHover = () => {
    //console.log('hiiii');
    if (!email) {
      setEmailReq(true);
    } else {
      setEmailReq(false);
    }
  };
  return (
    //show?
    <>
      <Modal
        // className="modal fade"
        // id="SignIn"
        // tabIndex="-1"
        // role="dialog"
        // aria-labelledby="SignIn"
        show={forgetShow}
        className="modal fade signwidth"
        centered
      >
        <Modal.Body className="p-0 m-0">
          <div className="border-none">
            <div className="row mx-0 ">
              <div className="col-5 px-0 d-none d-lg-block">
                <div className="  h-100">
                  <img
                    src={signupImage}
                    className=" img-fluid w-100 h-100 "
                    alt="main"
                  />
                </div>
              </div>
              {
                <div className="col-lg-7 col-12 px-0 ">
                  <div className="row mx-0">
                    <div className="col-12 text-end pe-md-2 pe-1 pt-2 px-0">
                      <div className="">
                        <button
                          type="button"
                          className="close  close-modal  "
                          data-dismiss="modal"
                          aria-label="Close"
                          style={{ color: "black" }}
                          onClick={() => handleforgetShow(false)}
                        >
                          <img src={x} className="x-close" alt="main" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className=" px-lg-5 pt-0 pt-md-0 px-2 ">
                    <div className="col-12 px-0 pt-md-4 pt-3 detail-txt">
                      {t("forget1")}
                    </div>
                    <div className="signupdesc pt-3 pb-mb-5  px-3 px-md-5">
                      {t("forget2")}
                    </div>

                    <form
                      className="px-3 px-md-2 pt-md-5 pt-4"
                      onSubmit={handleSubmit}
                    >
                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          <div className="mb-1">
                            <label
                              htmlFor="email"
                              className="form-label emailLabel"
                            >
                              {t("email")}
                            </label>
                            <input
                              type="text"
                              className="form-control formlogin2"
                              id="email"
                              placeholder={t("email")}
                              value={email}
                              name="email"
                              onChange={(e) => setEmail(e.target.value)}
                              aria-describedby="emailHelp"
                            />
                            <div
                              id="emailHelp"
                              className="error-text"
                              style={{
                                color: emailReq ? "red" : "gray",
                              }}
                            >
                              {emailVal}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div onMouseEnter={handleHover}>
                            <button
                              type="submit"
                              id="submit"
                              className="btn-join"
                              disabled={!email || email.length < 4}
                              onClick={
                                logining ? () => {} : () => sendForgetPassword()
                              }
                              style={{
                                display: !showVerify ? "block" : "none",
                              }}
                              //onMouseEnter={handleHover}\
                              aria-label="Reset Password"
                            >
                              {logining ? t("forget3") : t("Rest Password")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="row pt-md-4 pt-2 mx-0">
                      <div className="col-12 text-center login-linkforgotpass px-0">
                        {t("forget4")}
                        <Link
                          to="/"
                          className="login-linkforgotpass link px-1"
                          style={{ textDecoration: "underline" }}
                          data-dismiss="modal"
                          onClick={() =>
                            handleSignIn(true) & handleforgetShow(false)
                          }
                        >
                          {t("Register")}
                        </Link>
                      </div>
                    </div>
                    {/* <div className="row pt-md-4 pt-2">
                      <div className="col-12 text-center login-link">
                        <Link to="/" className="login-link link" onClick={()=>handleforgetShow(false)} data-dismiss="modal">
                          Continue as a guest
                        </Link>
                      </div>
                    </div> */}

                    <div className="row pt-md-4 pt-1 pb-4 mx-0 ">
                      <div className="col-12 text-center px-0 ">
                        <Link
                          to="/Privacy-policy"
                          className="learn-signup link "
                        >
                          {t("learnmoreSignIn")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
    //:null
  );
}

export default ForgetPassword;
